import {StrictMode, Suspense} from 'react';
import {createRoot} from 'react-dom/client';
import {RouterProvider} from 'react-router-dom';
import {router} from './router';
import {PageLoading} from './components';
import './styles.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Suspense fallback={<PageLoading />}><RouterProvider router={router} /></Suspense>
  </StrictMode>,
);
